// extracted by mini-css-extract-plugin
export var TopBanner = "styles-module--TopBanner--1kpNU";